import type { Connection } from '../../../types/electron';
import type { ActiveConnection } from '../../connections/models/connectionTypes';
import { getDatabaseFromConnectionId } from '../../connections/utils/getDatabaseFromConnectionId';

/** The two target fields a Target Connection switch must rewrite together. */
export interface CloneTargetFormFields {
  setFieldValue(name: 'targetDatabaseName' | 'targetSchema', value: string): void;
}

/**
 * Apply a Target Connection change to the clone form: prefill the new
 * connection's saved database AND reset the schema to the engine default.
 * Schemas are per-connection — carrying the previous connection's schema
 * across a switch silently targets a same-named schema on the new server, or
 * fails at clone time when it doesn't exist there.
 */
export function applyCloneTargetConnectionChange(
  form: CloneTargetFormFields,
  connectionId: string,
  connections: Connection[],
  activeConnections: ActiveConnection[],
  defaultSchema: string,
): void {
  form.setFieldValue(
    'targetDatabaseName',
    getDatabaseFromConnectionId(connectionId, connections, activeConnections) ?? '',
  );
  form.setFieldValue('targetSchema', defaultSchema);
}
